/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { ClearableSearchField } from "components/SearchField/SearchField";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog/DeleteConfirmationDialog";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useCallback, useEffect, useMemo, useState } from "react";
import { createTheme } from "react-data-table-component";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { deleteItemCategories, fetchCategories } from "utils/api";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import LoadingModal from "../../components/LoadingModel/loadingModal";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconMenu from "components/CustomMaterialMenu/Custom";
import { ContactsOutlined } from "@mui/icons-material";
// import ArchiveIcon from '@mui/icons-material/Archive';

createTheme(
  "solarized",
  {
    text: {
      primary: "white",
      secondary: "white",
    },
    background: {
      default: "var(--surface-primary, #191b1f)",
    },
    context: {
      background: "var(--surface-primary, #191b1f)",
      text: "white",
    },
    divider: {
      default: "white",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);
createTheme(
  "light",
  {
    text: {
      primary: "black",
      secondary: "black",
    },
    background: {
      default: "white",
    },
    context: {
      background: "white",
      text: "black",
    },
    divider: {
      default: "gray",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);
let searchParameter = "";
const SCREEN_NAME = "ItemCategories";
let categoryStatus = "Active";
let routePath = "/itemCategory";

function ItemCategory() {
  let changePaginationText =
    document.getElementsByClassName("rdt_Pagination")[0];
  if (changePaginationText !== undefined) {
    changePaginationText.getElementsByTagName("span")[0].textContent =
      "Records Per Page";
  }
  const [loading, setLoading] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("");
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [selectedRows, setSelectedRows] = useState();
  const [toggleCleared, setToggleCleared] = useState(false);
  const [title, setTitle] = useState("");
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const dispatch = useDispatch();
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [values, setValues] = useState({
    _id: [],
    sortingType: "",
    sortingField: "",
    categoryStatus: "All",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameterList: ["categoryName", "categoryCode", "categoryStatus"],
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
      ?.businessUserID,
  });

  useEffect(() => {
    (async () => {
      await getRight();
      await fetchCategory();
    })();
  }, [values.categoryStatus, values.sortingType, perPage, dispatch]);

  async function getRight() {
    let right = await getScreenRight("Categories");
    if (right === "Full Access") {
      setDisableColor(false);
    } else setDisableColor(true);
  }

  const handleCancel = (name) => (event) => {
    setSelectedRows([]);
    console.log("Before selectedRows", selectedRows);
    setDeleteDialogeFlag(false);
  };

  const handleDeleteDialogeClick = async (_id) => {
    values._id = _id;
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleDelete = async (id) => {
    deleteCategories();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = (page) => {
    values.page = page;
    fetchCategory();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setToggleCleared(!toggleCleared);
    setSelectedRows([]);
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const contextActions = useMemo(() => {
    const handleDeleteMultiple = () => {
      if (toggleCleared) setSelectedRows([]);
      setDeleteDialogeFlag(!deleteDialogeFlag);
      setDeleteHeading("Would you like to delete selected records? ");
      console.log(selectedRows);
      if (selectedRows) {
        console.log(selectedRows);
        values.selectedRows = selectedRows;
        // values._id =[];
        // for (let element of selectedRows) {

        //   values._id.push(element._id);
        // }
      }
    };

    return (
      <Grid container gap={3} display={"flex"}>
        <MDButton onClick={handleDeleteMultiple} color="error">
          Delete
        </MDButton>
      </Grid>
    );
  }, [selectedRows, toggleCleared]);

  // const handleRowSelected = useCallback(state => {
  //   setSelectedRows(state.selectedRows);
  //   if (state.selectedRows.length > 0) {
  //     setTitle(" ");
  //   }
  //   else {
  //     setTitle("");
  //     setDeleteHeading("");
  //   }
  // }, []);

  const handleRowSelected = useCallback((state) => {
    let data = state.selectedRows;
    if (data.length > 0) {
      setSelectedRows(data.map((a) => a._id));
      setTitle(" ");
    } else {
      setTitle("");
      setDeleteHeading("");
    }
  }, []);

  const deleteCategories = async () => {
    await deleteItemCategories(
      values,
      (data) => {
        setValues({ ...values, _id: [] });
        fetchCategory();
        setToggleCleared(true);
        setTitle("");
        showResMsg(
          data.Result_Status ? genericMessage.deleted : data.Result_Message,
          1000,
          data.Result_Status
        );
      },
      dispatch
    );
  };

  const fetchCategory = async () => {
    values.searchParameter = searchParameter;
    values.categoryStatus = categoryStatus;

    await fetchCategories(
      values,
      (data) => {
        setTotalRows(data.Result_Output.totalDocs);
        setRows(data.Result_Output.docs);
      },
      dispatch
    );
  };

  useEffect(() => {
    if (values.filterValues.length == "") {
      fetchCategory();
    }
  }, [values.filterValues]);

  useEffect(() => {
    categoryStatus = values.categoryStatus;
  }, [values.categoryStatus]);

  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
      },
    },
    headCells: {
      style: {
        // paddingLeft: '10px',
        paddingRight: "0px",
        fontWeight: "bold",
        fontSize: "14px",
        color: "white",
      },
    },
  };

  let columns = [
    {
      // name: "Category Name",
      name: <p style={{ fontSize: "12px" }}>Account Name</p>,
      // selector: row => row.categoryName,
      selector: (row) => (
        <span style={{ fontSize: "12px" }}>{row.categoryName}</span>
      ),
      sortable: true,
      sortField: "categoryName",
    },
    {
      // name: "Category Code",

      name: (
        <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Account Code</p>
      ),
      // selector: row => row.categoryCode,
      selector: (row) => (
        <span style={{ fontSize: "12px" }}>{row.categoryCode}</span>
      ),
      sortable: true,
      sortField: "categoryCode",
      center: true,
    },
    {
      // name: "Status",
      name: <p style={{ paddingLeft: "16px", fontSize: "12px" }}>Status</p>,
      // selector: row => row.categoryStatus,
      selector: (row) => (
        <span style={{ fontSize: "12px" }}>{row.categoryStatus}</span>
      ),
      sortable: true,
      sortField: "categoryStatus",
      center: true,
    },
    {
      // name: "Action(s)",
      name: <p style={{ fontSize: "12px" }}>Action(s)</p>,
      // selector: row => row._id,
      selector: (row) => <span style={{ fontSize: "12px" }}>{row._id}</span>,
      center: true,
      cell: (row) => (
        <IconMenu
          size="small"
          row={
            <>
              {/* <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}> */}
              <Grid style={{ width: "100%" }} item>
                <Link to={`/categories/edit/${row._id}`}>
                  <p style={darkMode ? { color: "white" } : { color: "black" }}>
                    <TimelineItem
                      color="success"
                      // icon="edit"
                      icon={<EditIcon className="actionicon" />}
                      title="Edit"
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit
                  </p>
                </Link>
              </Grid>
              <Grid style={{ width: "100%" }} item>
                <p
                  style={darkMode ? { color: "white" } : { color: "black" }}
                  data-clickable="true"
                  onClick={() => handleDeleteDialogeClick(row._id)}
                >
                  <TimelineItem
                    color="error"
                    // icon="delete"
                    icon={<DeleteIcon className="actionicon" />}
                    onClick={() => handleDeleteDialogeClick(row._id)}
                    title="Delete"
                  />{" "}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete
                </p>
              </Grid>
              {/* </Grid> */}
            </>
          }
        />
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName="Accounts" />
          <Grid
            container
            display={"flex"}
            justifyContent="end"
            mt={2.2}
            gap={2}
          >
            <Grid lg={2.5} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "38.11px" }}
                  label="Filter By Status"
                  value={values.categoryStatus}
                  onChange={(e) =>
                    setValues({ ...values, categoryStatus: e.target.value })
                  }
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <ClearableSearchField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchCategory();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <Button
                        style={{
                          borderRadius: "0px 0.3rem  0.3rem 0px",
                          boxShadow: "none",
                          background: barColor,
                        }}
                        variant="contained"
                        onClick={fetchCategory}
                      >
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: "16px" }}>
              <Link to={"/itemCategory/addItemCategory"}>
                <MDButton
                  variant="contained"
                  color="success"
                  style={{ height: "38.11px" }}
                >
                  Add New
                </MDButton>
              </Link>
            </div>
          </Grid>
          {/* <CardContent> */}
          <BTable
            theme={darkMode ? "solarized" : "light"}
            title={title}
            columns={columns}
            data={rows}
            selectable
            selectableRows
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            customStyles={customStyles}
            contextActions={contextActions}
            onSelectedRowsChange={handleRowSelected}
            clearSelectedRows={toggleCleared}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}
          />
          {/* </CardContent> */}
        </Card>
      </div>
      <DeleteConfirmationDialog
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
        message={deleteHeading}
      />
      <LoadingModal loading={loading} />
    </DashboardLayout>
  );
}

export default ItemCategory;
